// extracted by mini-css-extract-plugin
module.exports = {"mCard":"jf-z","image":"kf-z","imageNoBackground":"lf-z"};